import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { ABOUT_URL, HERO_CTAS, HERO_MONTAGE, type HeroCta } from '../content'
import styles from './Hero.module.css'

// The two CTAs follow the Press hero: primary = solid black (ink), secondary = outlined black.
function ctaProps(variant: HeroCta['variant']): { color: 'black'; kind?: 'secondary' } {
  switch (variant) {
    case 'primary':
      return { color: 'black' }
    case 'secondary':
      return { color: 'black', kind: 'secondary' }
  }
}

export function Hero(): React.ReactElement {
  return (
    <section className={styles.hero}>
      <Container className={styles.hero__inner}>
        <div className={styles.hero__text}>
          <nav className={styles.hero__breadcrumb} aria-label="Fil d'Ariane">
            <a href={ABOUT_URL}>À propos</a>
            <span aria-hidden="true">›</span>
            <span className={styles.hero__breadcrumbTag}>Kit de communication</span>
          </nav>
          <h1 className={styles.hero__title}>
            Logo &amp; Stickers <span className={styles.hero__highlight}>Ulule</span>
          </h1>
          <p className={styles.hero__lede}>
            Logos à télécharger et stickers à intégrer dans vos visuels pour communiquer à chaque étape de votre
            campagne de financement participatif.
          </p>
          <div className={styles.hero__actions}>
            {HERO_CTAS.map((cta) => (
              <plume.RoundButton key={cta.label} as="a" href={cta.href} size="big" {...ctaProps(cta.variant)}>
                {cta.label}
              </plume.RoundButton>
            ))}
          </div>
        </div>
        <div className={styles.hero__art}>
          <div className={styles.hero__montage} role="img" aria-label="Aperçu des stickers Ulule">
            {HERO_MONTAGE.map((sticker) => (
              <img key={sticker.name} className={styles.hero__sticker} src={sticker.png} alt="" />
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
